import React, { FunctionComponent } from 'react';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  t: (key: string) => string;
  navigation: {
    navigate: (path: string) => void;
  };
}

const UpcomingWorkoutsSliderCard: FunctionComponent<IProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    navigation,
    t,
  },
) => {

  const PTGroupImageHeight = 532;
  const PTGroupImageWidth = 692;

  return (
    <HorizontalScrollerCard
      style={workoutSliderCardStyle.container}
      onPress={() => navigation.navigate('UserDashboard')}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={PTGroupImageHeight}
        imageWidth={PTGroupImageWidth}
        header={t('upcomingWorkouts')}
        subHeading={t('seeWorkoutSchedule')}
        image={require('../../assets/images/workout-cards/crunch_on_mat.png')}
      />
    </HorizontalScrollerCard>
  );
};

export default UpcomingWorkoutsSliderCard;
